import { css, html, LitElement, type TemplateResult } from 'lit';
import { property } from 'lit/decorators.js';

/**
 * An AI icon whose stars twinkle while the AI works. CSS draws the motion on
 * the static icon, so no player runs and nothing is evaluated at runtime.
 */
export class AIAnimatedIcon extends LitElement {
  static override styles = css`
    :host {
      display: inline-flex;
      width: 20px;
      height: 20px;
    }
    svg {
      width: 100%;
      height: 100%;
    }
    path {
      transform-box: fill-box;
      transform-origin: center;
      animation: ai-icon-twinkle 2s ease-in-out infinite;
    }
    path:nth-of-type(even) {
      animation-delay: -1s;
    }
    @keyframes ai-icon-twinkle {
      0%,
      100% {
        transform: scale(1);
        opacity: 1;
      }
      50% {
        transform: scale(0.72);
        opacity: 0.6;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      path {
        animation: none;
      }
    }
  `;

  @property({ attribute: false })
  accessor icon!: TemplateResult;

  override render() {
    return this.icon;
  }
}

/** The icon with twinkling stars. */
export const animatedAIIcon = (icon: TemplateResult) =>
  html`<ai-animated-icon .icon=${icon}></ai-animated-icon>`;

declare global {
  interface HTMLElementTagNameMap {
    'ai-animated-icon': AIAnimatedIcon;
  }
}
